import RootWrapper from "./src/components/ui/root-wrapper";
import "./global.css";
import "@fontsource/barlow/300.css";
import "@fontsource/barlow/400.css";
import "@fontsource/barlow/500.css";
import "@fontsource/heebo/400.css";
import { logError } from "./src/functions/logError";

export const wrapRootElement = RootWrapper;

// Global error handling setup
export const onClientEntry = () => {
  // Capture uncaught errors to prevent crashes
  window.addEventListener("error", (event) => {
    // Log all errors to Strapi
    if (event.error) {
      console.error("Global Error Caught:", event.error);
      //logError(event.error, null, "gatsby-browser.js onClientEntry");
    }

    // Special handling for DOM manipulation errors
    if (
      event.error &&
      event.error.message &&
      (event.error.message.includes("insertBefore") ||
        event.error.message.includes("Node"))
    ) {
      console.log("Caught DOM manipulation error during navigation");
      event.preventDefault();

      // Recovery UI for cart page
      if (window.location.pathname.includes("/cart")) {
        // Only show recovery UI if there isn't already an error UI showing
        if (!document.querySelector(".error-recovery-ui")) {
          const cartContainer = document.querySelector("main");
          if (cartContainer) {
            // Create simple inline recovery UI
            const recoveryDiv = document.createElement("div");
            recoveryDiv.className = "error-recovery-ui";
            recoveryDiv.style.textAlign = "center";
            recoveryDiv.style.padding = "2rem";
            recoveryDiv.innerHTML = `
              <h3>We encountered an issue with your cart</h3>
              <p>Please try refreshing the page or returning to the homepage.</p>
              <button onclick="window.location.reload()" style="margin: 1rem; padding: 0.5rem 1rem;">Refresh Page</button>
              <button onclick="window.location.href='/'" style="margin: 1rem; padding: 0.5rem 1rem;">Go to Homepage</button>
            `;
            cartContainer.innerHTML = "";
            cartContainer.appendChild(recoveryDiv);
            // Log error to Strapi

            logError(
              event.error,
              null,
              "gatsby-browser.js onClientEntry - Cart Recovery UI",
            );
          }
        }
      }
    }
  });

  // Capture unhandled promise rejections
  window.addEventListener("unhandledrejection", (event) => {
    console.error("Unhandled Promise Rejection:", event.reason);

    // Log the error to Strapi
    logError({
      message: `Unhandled Promise Rejection: ${
        event.reason?.message || JSON.stringify(event.reason)
      }`,
      stack: event.reason?.stack,
      code: "PROMISE_REJECTION",
    });

    // Prevent the default handling
    event.preventDefault();
  });
};

// Add transition protection during page changes
export const onRouteUpdate = ({ location, prevLocation }) => {
  // If navigating from cart page, perform cleanup
  if (prevLocation && prevLocation.pathname.includes("/cart")) {
    // Clear any pending timeouts or intervals
    const highestTimeoutId = setTimeout(() => {}, 0);
    for (let i = 0; i < highestTimeoutId; i++) {
      clearTimeout(i);
    }

    // Force garbage collection for good measure (if browser supports it)
    if (window.gc) {
      window.gc();
    }
  }
};

// Handle route errors - this is a Gatsby-specific hook
export const onRouteUpdateDelayed = () => {
  // Show a loading indicator for slow page transitions
  const body = document.querySelector("body");

  // Create and append a loading indicator if it doesn't exist
  if (!document.getElementById("route-loading-indicator")) {
    const loadingDiv = document.createElement("div");
    loadingDiv.id = "route-loading-indicator";
    loadingDiv.style = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 4px;
      background: linear-gradient(to right, #f0f0f0, #8c6a56, #f0f0f0);
      animation: loadingAnimation 1.5s infinite;
      z-index: 9999;
    `;

    // Add the animation style
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes loadingAnimation {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
    `;
    document.head.appendChild(style);

    // Add the loading indicator to the page
    body.appendChild(loadingDiv);
  }
};

// Remove the loading indicator when route update completes
export const onPreRouteUpdate = () => {
  const loadingIndicator = document.getElementById("route-loading-indicator");
  if (loadingIndicator) {
    loadingIndicator.remove();
  }
};
